import { Button, Card, Col, Form } from 'react-bootstrap';
import './BeAnOwnerFormStepper.scss';
import React, { useEffect, useState } from 'react';
import AddRemoveButton from '../../../molecules/AddRemoveButton/AddRemoveButton';
import { useFormContext } from 'react-hook-form';
import GoogleAutocompleteControlled from '../../../atoms/GoogleAutocompleteControlled/GoogleAutocompleteControlled';

export interface StepProps {
  nextStep: Function;
  metros: Array<string>;
}

function Step01({ nextStep, metros }: StepProps) {
  const [bedrooms, setBedrooms] = useState(0);
  const [bathrooms, setBathrooms] = useState(1);
  const {
    register,
    handleSubmit,
    watch,
    control,
    setValue,
    formState: { errors }
  } = useFormContext();
  const formData = watch();

  const handleSetBathrooms = (value: any) => {
    setBathrooms(value);
    setValue('PropertyBathrooms', value);
  };

  const handleSetBedrooms = (value: any) => {
    setBedrooms(value);
    setValue('PropertyBedrooms', value);
  };

  return (
    <Card className={'card-stepper'}>
      <Card.Body>
        <Card.Subtitle className="mb-1 text-muted">Step 1 of 3</Card.Subtitle>
        <Card.Title>See how much you could earn!</Card.Title>
        <Card.Text>Tell us about your property and see how much you could earn by renting your home on Urbain</Card.Text>
        <Form.Row>
          <Form.Group as={Col} controlId="formGridPropertyAddress" xs={12} className={'my-2 px-0'}>
            <Form.Label className="form-label-info required">Your Rental Property Address</Form.Label>
            <GoogleAutocompleteControlled
              selectProps={{
                styles: {
                  container: (provided: any) => ({
                    ...provided,
                    flexGrow: 1
                  })
                }
              }}
              streetNumberFormField={{ name: 'PropertyStreetNumber' }}
              region={{ region: 'GB' }}
              addresFormField={{ name: 'PropertyStreetAddress' }}
              extendedAddresFormField={{ name: 'PropertyExtendedAddress' }}
              localityFormField={{ name: 'PropertyLocality' }}
              regionFormField={{ name: 'PropertyRegion' }}
              postalCodeFormField={{ name: 'PropertyPostalCode', rules: { required: 'Address information is required.' } }}
              countryFormField={{ name: 'PropertyCountryName', rules: { required: true } }}
            />
            {errors.PropertyPostalCode && (
              <Form.Control.Feedback type="invalid" className="display-block">
                {errors.PropertyPostalCode.message || 'Error'}
              </Form.Control.Feedback>
            )}
          </Form.Group>
        </Form.Row>
        <Form.Row>
          <Form.Group xs={12} as={Col} controlId="metro" className={'p-0'}>
            <Form.Label className="form-label-info required">Metro</Form.Label>
            <Form.Control
              as="select"
              {...register('Metro', {
                required: 'Metro required'
              })}
            >
              {!!metros && !!metros.length && metros.map(metr => <option value={metr}>{metr}</option>)}
            </Form.Control>
            {errors.Metro && (
              <Form.Control.Feedback type="invalid" className="display-block">
                {errors.Metro.message || 'Error'}
              </Form.Control.Feedback>
            )}
          </Form.Group>
        </Form.Row>
        <Form.Row className={'d-block border-bottom pt-2 pb-2 '}>
          <Form.Group controlId="form.PropertyBedrooms" className={'flex space-between align-center mb-0'}>
            <Form.Label className={'mb-0'}>{bedrooms} Bedrooms</Form.Label>
            <AddRemoveButton addFn={handleSetBedrooms} removeFn={handleSetBedrooms} step={1} currentValue={bedrooms} minValue={0} />
          </Form.Group>
        </Form.Row>
        <Form.Row className={'d-block py-2'}>
          <Form.Group controlId="form.PropertyBathrooms" className={'flex space-between align-center mb-0'}>
            <Form.Label className={'mb-0'}>{bathrooms} Bathrooms</Form.Label>
            <AddRemoveButton addFn={handleSetBathrooms} removeFn={handleSetBathrooms} step={0.5} currentValue={bathrooms} minValue={1} />
          </Form.Group>
        </Form.Row>
      </Card.Body>
      <Card.Footer>
        <Button onClick={() => nextStep(2)} className={'next-button mt-2'} disabled={!formData.PropertyPostalCode}>
          Next
        </Button>
      </Card.Footer>
    </Card>
  );
}

export default Step01;
